import FeatureSnippetChoices from './FeatureSnippetChoices';

export default FeatureSnippetChoices;
export { FeatureSnippetChoices };
